import * as Yup from 'yup';

export interface IShipmentConsigneeDetail {
  tcShipmentConsigneeOrder?: string;
  tcShipmentNo: string;
  tcShipmentDate: string;
  tcShipmentDocNo: string;
  tcGrossShippingWeight: string;
  tcShipmentInvoiceReferences: string[];
  consigneeName: string;
  consigneeTeId: string;
  consigneeAddress1: string;
  consigneeAddress2: string;
  consigneeAddress3: string;
  consigneePostcode: string;
  consigneeTown: string;
  consigneeStateOrProvince: string;
  consigneeCountryOrArea: string;
  isConsigneeTeCertified?: string;
}

export interface IShipments {
  tcId: string;
  tcGrossShippingWeight: string;
  tcShipmentConsigneeDetails: IShipmentConsigneeDetail[];
}

export const shipmentsIntialValues: IShipments = {
  tcId: "",
  tcGrossShippingWeight: "",
  tcShipmentConsigneeDetails: [
    {
      tcShipmentConsigneeOrder: "",
      tcShipmentNo: "",
      tcShipmentDate: "",
      tcShipmentDocNo: "",
      tcGrossShippingWeight: "",
      tcShipmentInvoiceReferences: [],
      consigneeName: "",
      consigneeTeId: "",
      consigneeAddress1: "",
      consigneeAddress2: "",
      consigneeAddress3: "",
      consigneePostcode: "",
      consigneeTown: "",
      consigneeStateOrProvince: "",
      consigneeCountryOrArea: "",
      isConsigneeTeCertified: "Y"
    }
  ]
};


// Map function
export const mapToIShipmentConsigneeDetails = (
  details: any[]
): IShipmentConsigneeDetail[] => {
  return details.map((detail) => ({
    tcShipmentConsigneeOrder: detail.tcShipmentConsigneeOrder || undefined,
    tcShipmentNo: detail.tcShipmentNo,
    tcShipmentDate: detail.tcShipmentDate,
    tcShipmentDocNo: detail.tcShipmentDocNo,
    tcGrossShippingWeight: detail.tcGrossShippingWeight.toString(),
    tcShipmentInvoiceReferences: detail.tcShipmentInvoiceReferences || [],
    consigneeName: detail.consigneeName,
    consigneeTeId: detail.consigneeTeId,
    consigneeAddress1: detail.consigneeAddress1,
    consigneeAddress2: detail.consigneeAddress2,
    consigneeAddress3: detail.consigneeAddress3,
    consigneePostcode: detail.consigneePostcode,
    consigneeTown: detail.consigneeTown,
    consigneeStateOrProvince: detail.consigneeStateOrProvince,
    consigneeCountryOrArea: detail.consigneeCountryOrArea,
    isConsigneeTeCertified: detail.isConsigneeTeCertified || undefined, // Optional field
  }));
};


export const mapToShipmentConsigneeDetailJsonObject = (json: any): IShipmentConsigneeDetail => {
  return {
    tcShipmentConsigneeOrder: "", // Set to undefined or provide default if needed
    tcShipmentNo: json.tcShipmentNo,
    tcShipmentDate: json.tcShipmentDate,
    tcShipmentDocNo: json.tcShipmentDocNo,
    tcGrossShippingWeight: json.tcGrossShippingWeight,
    tcShipmentInvoiceReferences: json.tcShipmentInvoiceReferences,
    consigneeName: json.consigneeName,
    consigneeTeId: json.consigneeTeId,
    consigneeAddress1: json.consigneeAddress1,
    consigneeAddress2: json.consigneeAddress2 || "", // Default empty if missing
    consigneeAddress3: json.consigneeAddress3 || "", // Default empty if missing
    consigneePostcode: json.consigneePostcode,
    consigneeTown: json.consigneeTown,
    consigneeStateOrProvince: json.consigneeStateOrProvince,
    consigneeCountryOrArea: json.consigneeCountryOrArea,
    isConsigneeTeCertified: json.isConsigneeTeCertified || 'Y', // Default empty or provide default value if needed
  };
}